<script>
import { connect } from 'vuex-connect';
import GamesByTagsBox from '../scenes/GamesByTagsBox.vue';

export default connect({
  gettersToProps: {
    stationTags: 'launcherStationTagsWithGames',
  },
  stateToProps: {
    loading (state) {
      return !this.$store.getters.currentStation.safetyMode && state.launcher.loadings.stationTags;
    },
    error: state => state.launcher.errors.stationTags,
  },
  lifecycle: {
    created ({ dispatch, state, getters }) {
      if (!state.launcher.stationTagIds.length) dispatch('getStationTags');
    },
  },
})('GamesByTagsBox', GamesByTagsBox);
</script>
